import React, { useState, useContext, useEffect, useRef } from "react";
import { api } from "../../api";
import Ctx from "../../contexts/AppContext";
import Ic from "../common/Ic";
import Avatar from "../common/Avatar";
import PushToggle from "../common/PushToggle";
import { LANGUAGES } from "../../i18n";
import { rad, sp } from "../../constants/styles";

export default function TopBar() {
  const { t, h, lang, setLang, dk, setDk, role, notifs = [], setNotifs, currUserId, go, setOpenChat, setSelMaintId, doLogout, flash, plan, orgName, userName, userAvatar, replayTours } = useContext(Ctx);
  const [showNotifs, setShowNotifs] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const notifRef = useRef(null);
  const notifBtnRef = useRef(null);
  const settsRef = useRef(null);
  const settsBtnRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (showNotifs && notifRef.current && !notifRef.current.contains(event.target) && !notifBtnRef.current.contains(event.target)) {
        setShowNotifs(false);
      }
      if (showSettings && settsRef.current && !settsRef.current.contains(event.target) && !settsBtnRef.current.contains(event.target)) {
        setShowSettings(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showNotifs, showSettings]);

  const ct = currUserId;
  // Filter notifications strictly by role and user ID — no cross-user leaking
  const myNotifs = (() => {
    const all = notifs || [];
    if (role === "landlord") return all.filter(n => n.forRole === "landlord");
    if (role === "tenant")   return all.filter(n => n.forRole === "tenant" && n.forTid === ct);
    if (role === "service")  return all.filter(n => n.forRole === "service" && n.forTid === ct);
    if (role === "admin")    return all.filter(n => n.forRole === "admin");
    return [];
  })();
  const unread = myNotifs.filter(n => !n.read).length;
  const markAllRead = () => {
    setNotifs(prev => (prev || []).map(n => {
      let isMine = false;
      if (role === "landlord") isMine = n.forRole === "landlord";
      else if (role === "tenant") isMine = n.forRole === "tenant" && n.forTid === ct;
      else if (role === "service") isMine = n.forRole === "service" && n.forTid === ct;
      else if (role === "admin") isMine = n.forRole === "admin";
      return isMine ? { ...n, read: true } : n;
    }));
    api.markRead(role, ct);
  };

  // (Export CSV removed from the gear menu — full CSV exports live on
  // the Reports page. The old exportToCsv helper was dropped with it.)

  return <div style={{ background: `${h.bg}e8`, backdropFilter: "saturate(180%) blur(24px)", WebkitBackdropFilter: "saturate(180%) blur(24px)", borderBottom: `1px solid ${h.bd}`, padding: "10px 16px", display: "flex", alignItems: "center", justifyContent: "space-between", position: "sticky", top: 0, zIndex: 999 }}>
    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
      <div style={{ width: 34, height: 34, borderRadius: rad.sm + 2, background: `${h.ac}12`, display: "flex", alignItems: "center", justifyContent: "center" }}><Ic n="bldg" s={17} c={h.ac} /></div>
      <div>
        <div style={{ color: h.tx, fontWeight: 800, fontSize: 15, letterSpacing: "-0.3px" }}>Pro<span style={{ color: h.ac }}>Rentz</span></div>
        <div style={{ color: h.ts || h.sc, fontSize: 11, fontWeight: 500 }}>{role === "landlord" ? t.landlord : role === "admin" ? (t.superAdmin || "Super Admin") : role === "service" ? (t.servicePerson || "Service") : t.tenant}</div>
      </div>
    </div>
    <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
      {/* Own profile picture (DP). Tap → manage it (Settings for
          landlords, Profile for tenant/service). Shows the uploaded
          image, else a colored initial. */}
      <button
        onClick={() => go(role === "landlord" ? "settings" : "profile")}
        aria-label={t.profile || "Profile"}
        title={userName || orgName || (t.profile || "Profile")}
        style={{ background: "none", border: "none", padding: 0, cursor: "pointer", display: "flex", borderRadius: "50%", marginRight: 2 }}
      >
        <Avatar src={userAvatar} name={userName || orgName} size={30} ring={`2px solid ${h.bd}`} />
      </button>
      <div style={{ position: "relative" }}>
        <button data-coach="notif-bell" ref={notifBtnRef} onClick={() => { setShowNotifs(!showNotifs); if (!showNotifs) markAllRead(); }} style={{ background: h.ib, border: `1px solid ${h.bd}`, padding: "7px 8px", borderRadius: rad.sm, cursor: "pointer", display: "flex", position: "relative" }}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={h.ts || h.sc} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9" /><path d="M13.73 21a2 2 0 01-3.46 0" /></svg>
          {unread > 0 && <div style={{ position: "absolute", top: -3, right: -3, background: h.rd, color: "#fff", fontSize: 9, fontWeight: 700, width: 16, height: 16, borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", boxShadow: `0 2px 6px ${h.rd}40` }}>{unread}</div>}
        </button>
        {showNotifs && <div ref={notifRef} className="animate-scaleIn" style={{ position: "absolute", top: 44, right: 0, width: 300, maxHeight: 380, overflowY: "auto", background: h.cd, borderRadius: rad.lg, boxShadow: h.s3 || "0 8px 30px rgba(0,0,0,.25)", zIndex: 100, padding: sp.sm, border: `1px solid ${h.bd}` }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 10px 6px" }}><span style={{ color: h.tx, fontWeight: 700, fontSize: 14 }}>{t.notif}</span>
            <button onClick={() => setShowNotifs(false)} style={{ background: h.ib, border: "none", color: h.ts || h.sc, cursor: "pointer", fontSize: 14, width: 28, height: 28, borderRadius: rad.sm, display: "flex", alignItems: "center", justifyContent: "center" }}>{"\u2715"}</button></div>
          {myNotifs.length === 0 && <div style={{ color: h.tt || h.sc, fontSize: 13, textAlign: "center", padding: 28 }}>{t.noNotif}</div>}
          {myNotifs.slice(0, 15).map(n => {
            // Deep-link: determine target page based on notification type + role
            const getTarget = () => {
              const ty = n.type || "";
              if (ty.startsWith("chat")) {
                if (role === "tenant") return "tenChat";
                const pid = ty.split(":")[1];
                if (pid) setOpenChat(pid);
                return "chatList";
              }
              // "job:<maintId>" — used for landlord→service assignment notifications.
              // Routes the SP to their My Jobs list (where the Accept button lives);
              // selMaintId is set so the list can highlight/scroll to that specific job.
              if (ty.startsWith("job:")) {
                const jobId = ty.slice(4);
                if (role === "service") {
                  if (jobId && setSelMaintId) setSelMaintId(jobId);
                  return "spJobs";
                }
                return "maint";
              }
              if (ty === "payment" || ty === "rent") return role === "tenant" ? "pay" : "pay";
              if (ty === "maintenance" || ty === "maint") return role === "tenant" ? "maint" : "maint";
              if (ty === "lease" || ty === "agreement") return role === "tenant" ? "tenLease" : "agreement";
              if (ty === "tenant_request" || ty === "approval") return role === "tenant" ? "dash" : "tens";
              if (ty === "lead") return role === "landlord" ? "leads" : "dash";
              if (ty === "service" || ty === "job") return role === "service" ? "dash" : "maint";
              if (ty === "alert") return "dash";
              // Default: go to dashboard
              return "dash";
            };
            return <div key={n.id} onClick={() => {
              const target = getTarget();
              go(target);
              setShowNotifs(false);
            }} style={{ padding: "10px 10px", borderRadius: rad.sm, marginBottom: 2, background: n.read ? "transparent" : `${h.ac}06`, cursor: "pointer", transition: "background 0.15s" }}>
              <div style={{ display: "flex", gap: 8, alignItems: "flex-start" }}>
                <div style={{ width: 8, height: 8, borderRadius: 4, background: (n.type || "").startsWith("chat") ? h.ac : n.type === "payment" || n.type === "rent" ? h.gn : n.type === "lease" || n.type === "agreement" ? h.ac : n.type === "maintenance" || n.type === "maint" ? "#f59e0b" : h.wn, marginTop: 5, flexShrink: 0 }} />
                <div style={{ flex: 1 }}>
                  <div style={{ color: h.tx, fontSize: 13, lineHeight: 1.4 }}>{n.msg}</div>
                  <div style={{ color: h.tt || h.sc, fontSize: 11, marginTop: 3 }}>{n.time}</div>
                </div>
                <span style={{ color: h.ac, fontSize: 11, marginTop: 4, flexShrink: 0 }}>{"\u203A"}</span>
              </div>
            </div>;
          })}
        </div>}
      </div>
      <div style={{ position: "relative" }}>
        <button data-coach="settings-gear" ref={settsBtnRef} onClick={() => setShowSettings(!showSettings)} style={{ background: h.ib, border: `1px solid ${h.bd}`, padding: "7px 8px", borderRadius: rad.sm, cursor: "pointer", display: "flex" }}><Ic n="gear" s={15} c={h.ts || h.sc} /></button>
        {showSettings && <div ref={settsRef} className="animate-scaleIn" style={{ position: "absolute", top: 44, right: 0, width: 260, background: h.cd, borderRadius: rad.lg, boxShadow: h.s3 || "0 8px 30px rgba(0,0,0,.25)", zIndex: 100, padding: sp.sm, border: `1px solid ${h.bd}`, maxHeight: "calc(100vh - 60px)", overflowY: "auto", WebkitOverflowScrolling: "touch" }}>
          <div style={{ padding: "8px 12px", marginBottom: 4, fontWeight: 700, color: h.tx, fontSize: 14 }}>{t.settings}</div>
          {/* Current Plan Card — always clickable → Settings for plan management */}
          {role === "landlord" && plan && (() => {
            const isMaxPlan = plan.type === "pro";
            const isPaid = plan.type !== "free";
            const isExpired = plan.planStatus === "expired";
            // When the master subscriptions toggle is OFF, the synthetic
            // 'unlimited' plan stands in. There's nothing to upgrade to
            // (everyone has full access), so we hide the CTA chevron
            // and the change-plan footer link below.
            const isSubsOff = plan.subscriptionsDisabled === true || plan.type === "unlimited";
            const isExpiring = isPaid && plan.daysRemaining != null && plan.daysRemaining <= 7 && plan.daysRemaining > 0;
            const borderColor = isExpired ? h.rd + "40" : isExpiring ? h.wn + "40" : isPaid ? h.gn + "30" : h.bd;
            const bgColor = isExpired ? `${h.rd}06` : isExpiring ? `${h.wn}06` : isPaid ? `${h.gn}08` : `${h.ac}08`;
            return <div onClick={() => { go("settings"); setShowSettings(false); }} style={{ margin: "4px 8px 10px", padding: "10px 12px", borderRadius: rad.md || 10, background: bgColor, border: `1px solid ${borderColor}`, cursor: "pointer", transition: "all 0.15s ease" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div>
                  <div style={{ color: h.tt || h.sc, fontSize: 9, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5 }}>{t.currentPlan || "Current Plan"}</div>
                  <div style={{ color: h.tx, fontWeight: 700, fontSize: 14, marginTop: 2 }}>{plan.name || (plan.type === "free" ? "Free" : (plan.type ? plan.type.split('_').map(s => s.charAt(0).toUpperCase() + s.slice(1)).join(' ') : "—"))}</div>
                </div>
                {isExpired
                  ? <span style={{ background: `${h.rd}15`, color: h.rd, padding: "3px 10px", borderRadius: 12, fontSize: 10, fontWeight: 700 }}>Expired</span>
                  : isPaid
                    ? <span style={{ background: `${h.gn}15`, color: h.gn, padding: "3px 10px", borderRadius: 12, fontSize: 10, fontWeight: 700 }}>{"\u2713 Active"}</span>
                    : <span style={{ background: h.pp || h.ac, color: "#fff", borderRadius: 8, padding: "4px 12px", fontSize: 11, fontWeight: 700 }}>{t.planUpgrade || "Upgrade"}</span>
                }
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 8 }}>
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                  <div style={{ color: h.sc, fontSize: 10 }}>{"\uD83C\uDFE0"} {plan.currentCount || 0}/{plan.maxProperties === 999999 ? "\u221E" : (plan.maxProperties || 2)}</div>
                  {isPaid && plan.daysRemaining != null && <div style={{ color: isExpired ? h.rd : isExpiring ? h.wn : h.sc, fontSize: 10, fontWeight: isExpiring || isExpired ? 700 : 400 }}>{"\u23F3"} {plan.daysRemaining > 0 ? `${plan.daysRemaining}d left` : "Expired"}</div>}
                  {!isPaid && plan.features && <div style={{ color: h.sc, fontSize: 10 }}>{"\u2728"} {plan.features.length} features</div>}
                </div>
                <div style={{ color: isSubsOff ? h.gn : isExpired ? h.rd : h.ac, fontSize: 10, fontWeight: 600 }}>
                  {isSubsOff
                    ? "View details"
                    : isExpired
                      ? `${t.renewPlan || "Renew"} \u203A`
                      : !isMaxPlan
                        ? `${(isPaid ? (t.changePlan || "Change Plan") : (t.planUpgrade || "Upgrade"))} \u203A`
                        : `${t.managePlan || "Manage"} \u203A`}
                </div>
              </div>
            </div>;
          })()}
          {/* PREFERENCES section — language dropdown + push + dark mode */}
          <div style={{ padding: "8px 12px 4px", marginTop: 4 }}><span style={{ color: h.tt || h.sc, fontSize: 10, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5 }}>{t.preferences || "Preferences"}</span></div>
          <div style={{ padding: "4px 12px 8px", position: "relative" }}>
            <select
              value={lang}
              onChange={(e) => setLang(e.target.value)}
              style={{
                width: "100%", appearance: "none", WebkitAppearance: "none", MozAppearance: "none",
                padding: "8px 32px 8px 12px",
                borderRadius: rad.sm, border: `1px solid ${h.bd}`,
                background: h.ib, color: h.tx,
                fontSize: 13, fontWeight: 600, cursor: "pointer",
                outline: "none", colorScheme: dk ? "dark" : "light",
              }}
            >
              {LANGUAGES.map(l => (
                <option key={l.code} value={l.code}>
                  {l.native}{l.native !== l.name ? ` (${l.name})` : ""}
                </option>
              ))}
            </select>
            {/* custom chevron (native arrow hidden via appearance:none) */}
            <span style={{ position: "absolute", right: 22, top: "50%", transform: "translateY(-50%)", pointerEvents: "none", color: h.ts || h.sc, fontSize: 10 }}>{"▾"}</span>
          </div>
          {/* Web Push toggle — single source of truth, visible to every role
              from one place (no Settings/Profile/Dashboard duplication).
              Renders as a compact menu row matching the rows below. */}
          <PushToggle />
          {/* Section-grouped rows. `__hdr` / `__div` sentinels render a
              section header / divider; everything else is a normal row.
              Role filtering happens inline; falsy entries are dropped so
              a section never shows an empty header. */}
          {[
            [t.dark, dk ? t.onTxt : t.offTxt, () => setDk(!dk)],

            // ── MANAGE ──
            ["__div"],
            ["__hdr", t.manage || "Manage"],
            // Explicit Settings row for landlords (in addition to the
            // Current Plan card, which also opens it) \u2014 a clear, labelled
            // entry point users expect to find in this list.
            role === "landlord" ? ["\u2699\ufe0f " + (t.settings || "Settings"), "\u2192", () => { go("settings"); setShowSettings(false); }] : null,
            (role === "tenant" || role === "service") ? [t.profile || "Profile", "\u2192", () => { go("profile"); setShowSettings(false); }] : null,
            role === "landlord" ? ["\ud83d\udcc8 Analytics", "\u2192", () => { go("analytics"); setShowSettings(false); }] : null,
            role === "landlord" ? [t.reports || "Reports", "\u2192", () => { go("reports"); setShowSettings(false); }] : null,
            role === "landlord" ? ["\uD83D\uDCE6 Vacate Inbox", "\u2192", () => { go("vacateInbox"); setShowSettings(false); }] : null,
            role === "landlord" ? ["\u26A1 AI Assistant", "\u2192", () => { go("aiAssistant"); setShowSettings(false); }] : null,
            role === "tenant" ? [t.viewAgr, "\u2192", () => { go("tenAgr"); setShowSettings(false); }] : null,

            // \u2500\u2500 HELP & LEGAL \u2500\u2500
            ["__div"],
            ["__hdr", t.helpLegal || "Help & Legal"],
            // State-aware Rent Act FAQ. Shown to every role (landlord +
            // tenant + service) since rent law affects all of them, but
            // with role-aware framing — "Know Your Rights" for tenants,
            // "Rent Act Guide" for landlords (RentActFAQ.js handles this).
            (role === "tenant" || role === "service")
                ? [t.knowYourRights || "Know Your Rights", "\u2192", () => { go("faq"); setShowSettings(false); }]
                : role === "landlord"
                ? [t.rentActGuide || "Rent Act Guide", "\u2192", () => { go("faq"); setShowSettings(false); }]
                : null,
            // Always-visible Terms + Privacy links — every user has the
            // right to re-read what they accepted at signup. Privacy
            // also satisfies DPDP Act Section 5 transparency duty.
            [t.termsAndConditions || "Terms & Conditions", "\u2192", () => { go("terms"); setShowSettings(false); }],
            [t.privacyPolicy || "Privacy Policy", "\u2192", () => { go("privacy"); setShowSettings(false); }],
            // "Show Tour Again" \u2014 re-runs both the welcome modal and
            // the coach-mark tour. Only useful for roles with an
            // onboarding (admin has none). Tour replay clears the
            // completion flags so the FTUE auto-opens immediately.
            (role === "landlord" || role === "tenant" || role === "service")
                ? ["\uD83D\uDDFA\uFE0F " + (t.showTourAgain || "Show Tour Again"), "\u21BB", () => {
                    if (replayTours) {
                        replayTours();
                        setShowSettings(false);
                        if (flash) flash(t.tourReplayStarted || "Restarting the tour\u2026");
                    }
                  }]
                : null,

            // \u2500\u2500 LOGOUT \u2500\u2500
            ["__div"],
            [t.logout, "\u2192", () => { doLogout(); setShowSettings(false); }]
          ].filter(Boolean).map((item, i) => {
            // Section sentinels render a divider / header instead of a row.
            if (item[0] === "__div") return <div key={i} style={{ height: 1, background: h.bd, margin: "6px 8px" }} />;
            if (item[0] === "__hdr") return <div key={i} style={{ padding: "8px 12px 4px", marginTop: 4 }}><span style={{ color: h.tt || h.sc, fontSize: 10, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5 }}>{item[1]}</span></div>;
            const [l, v, a] = item;
            return <div key={i} onClick={a} style={{ padding: "10px 12px", borderRadius: rad.sm, cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: 13, color: h.tx, transition: "background 0.15s" }}>
              <span style={{ fontWeight: 500 }}>{l}</span><span style={{ fontWeight: 600, color: l === t.logout ? h.rd : h.ac, fontSize: 12 }}>{v}</span></div>;
          })}
        </div>}
      </div>
    </div>
  </div>;
}
